// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".quiz__number[data-v-189787d6]{display:flex;align-items:center}.let[data-v-189787d6]{margin-left:8px;color:#5a6c7d;line-height:1;font-size:21px}", ""]);
// Exports
module.exports = exports;
